export enum VideoPlatform {
  Zoom = "zoom",
  Twilio = "twilio",
}

export const VIDEO_PLATFORMS = new Set<VideoPlatform>(
  Object.values(VideoPlatform),
);

/** Treats null/undefined as Twilio (the legacy default). */
export function normalizeVideoPlatform(
  platform: VideoPlatform | null | undefined,
): VideoPlatform {
  return platform ?? VideoPlatform.Twilio;
}

/** Null-safe comparison — null/undefined are treated as Twilio. */
export function videoPlatformsMatch(
  a: VideoPlatform | null | undefined,
  b: VideoPlatform | null | undefined,
): boolean {
  return normalizeVideoPlatform(a) === normalizeVideoPlatform(b);
}
